<div class="compliances-container">
  <app-compliance-tasks
    [columns]="columns"
    [data]="complianceData"
    [isLoading]="isLoading"
    [isLoadingMore]="isLoadingMore"
    [hasError]="hasError"
    [isComplianceLibrary]="true"
    (rowClicked)="onRowClick($event)"
    (assignClicked)="onAssignClick($event)"
    (archiveClicked)="onArchiveClickAsync($event)"
    (searchChanged)="onSearch($event)"
    (statusFilterChanged)="onStatusFilter($event)"
    (scrolledDown)="onScrollDown()">
  </app-compliance-tasks>
</div>